"use client";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation } from "swiper/modules";
import "swiper/css";
import "swiper/css/scrollbar";
import "swiper/css/pagination";
import { MainShopProduct } from "@/core/models/shop-product-model";
import FamilyProductCard from "../../components/FamilyProductCard";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { Heading } from "@/components/ui/Heading";
import { useDictionary } from "@/core/hooks/use-dictionary";
import CustomButton from "../../components/CustomButton";

type SwiperRelatedProductsProps = {
  items: MainShopProduct[];
  // سرور فچ می‌شه (نه با هوک useSiteSettings سمت کلاینت) تا قیمت از همون اولین
  // رندر با مالیات نشون داده بشه، نه اینکه اول بدون مالیات بیاد و بعد از لود
  // تنظیمات یهو عوض بشه (باعث می‌شد قیمتِ محصولات مرتبط با بقیه‌ی جاهای سایت
  // فرق کنه).
  settings?: any;
};

export default function SwiperRelatedProducts({
  items,
  settings,
}: SwiperRelatedProductsProps) {
  const { dictionary } = useDictionary()


  return (
    <div className="relative p-4">
      {/* header */}
      <div className="flex justify-between items-center mb-4">
        <Heading level={3} className="mb-0 flex-1 border-b border-b-primary-100 me-4 pb-2">
          {dictionary.forms?.related_products}
        </Heading>
        {/* button */}
        <div className="flex gap-2">
          <CustomButton className="swiper-button-prev-custom w-8 h-8 rounded-full border border-primary-900 bg-white text-primary-900 flex items-center justify-center">
            <ChevronRight className="w-4.5 h-4.5 stroke-1" />
          </CustomButton>
          <CustomButton className="swiper-button-next-custom w-8 h-8 rounded-full border border-primary-900 bg-white text-primary-900 flex items-center justify-center">
            <ChevronLeft className="w-4.5 h-4.5 stroke-1" />
          </CustomButton>
        </div>
      </div>

      {/* Swiper */}
      <Swiper
        modules={[Navigation]}
        spaceBetween={16}
        slidesPerView="auto"
        speed={700}
        navigation={{
          nextEl: ".swiper-button-next-custom",
          prevEl: ".swiper-button-prev-custom",
        }}
        className="w-full"
      >
        {items.map((item) => (
          <SwiperSlide key={item.id} style={{ width: "460px" }}>
            <FamilyProductCard product={item} settings={settings} />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
}
